import {InjectionToken} from '@angular/core';

export const CONFIG = new InjectionToken('CONFIG');
export const ENVIRONMENT = new InjectionToken('ENVIRONMENT');
export const LOGO = new InjectionToken('LOGO');
export const NAVIGATION = new InjectionToken('NAVIGATION');
  